const state = {
  show: false,
  message: '',
  color: 'error',
  timeout: 3000,
}

const mutations = {
  SHOW_TOAST(state, { message, color, timeout }) {
    state.message = message
    state.color = color || 'error'
    state.timeout = timeout || 3000
    state.show = true
  },
  HIDE_TOAST(state) {
    state.show = false
  },
}

const actions = {
  error({ commit }, message) {
    commit('SHOW_TOAST', { message, color: 'error' })
  },
  success({ commit }, message) {
    commit('SHOW_TOAST', { message, color: 'success' })
  },
  warning({ commit }, message) {
    commit('SHOW_TOAST', { message, color: 'warning' })
  },
  info({ commit }, message) {
    commit('SHOW_TOAST', { message, color: 'info' })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
